<h2>Lizenz bereits bestellt</h2>
<p>
  Die Verlängerung wurde bereits am {{organization.newLicenseOrderDate | date: "dd.MM.yyyy"}} bestellt.
  Eine erneute Bestellung ist nicht erforderlich. Bei Fragen zum Stand der Bestellung wenden Sie
  sich bitte an <a href="mailto:info@spr-plus.ch">info@spr-plus.ch</a>.
</p>
